import { Splide } from '@splidejs/splide';
import { isDefined } from "./helpers";

export function initHeader()
{
    openMenu();
    hideMenu();
    initSliderHeaderAccueil();
    changeBackgroundMenu();
    initBackdrop();
}

function openMenu()
{
    const buttonOpen = document.querySelector('#open-menu');

    if(!isDefined(buttonOpen)) return;

    buttonOpen.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('#menu').classList.add('open');
        document.body.classList.add('menu-is-open');
    });

}

function initBackdrop()
{
    const backdrop = document.querySelector('.header-menu-backdrop');
    if(!isDefined(backdrop)) return;

    backdrop.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('#menu').classList.remove('open');
        document.body.classList.remove('menu-is-open');
    });
}

function hideMenu()
{  
    const closeButton = document.querySelector('#close-menu');
    if(!isDefined(closeButton)) return;

    closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('#menu').classList.remove('open');
        document.body.classList.remove('menu-is-open');
    });
}

function initSliderHeaderAccueil()
{
    const headerSlider = document.querySelector('.header-content_slider');
    const headerSliderImage = document.querySelector('.header-images-slider');

    if(!isDefined(headerSlider)) return;

    let slider_header = new Splide( headerSlider, {
        speed : "500",   
        interval : "5000",
        autoplay: true,
        waitForTransition: false,
        pagination: false,
        arrows: false,
        type: 'fade',
        rewind: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        resetProgress:false,
    })

    let slider_header_image = new Splide( headerSliderImage, {
		width : '100vw',
		height: '100%',
        waitForTransition: false,
        pagination: false,
        arrows: false,
        type: 'fade',
        rewind: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        drag: false,
        lazyLoad: true
    })

    slider_header.sync(slider_header_image);

    // Collects LI elements:
    var thumbnails = document.querySelectorAll( '.header-slider-pagination-item' );
    var bars    = document.querySelectorAll( '.header-slider-pagination-item-progress-bar' );
    var current;

    for ( var i = 0; i < thumbnails.length; i++ ) {
        initThumbnail( thumbnails[ i ], i );
    }

    // The function to initialize each thumbnail.
    function initThumbnail( thumbnail, index ) {
        thumbnail.addEventListener( 'click', function () {
            slider_header.go( index );
        });
        
        thumbnail.addEventListener( 'mouseenter', function () {
            slider_header.Components.Autoplay.pause();
        });

        thumbnail.addEventListener( 'mouseleave', function () {
            slider_header.Components.Autoplay.play();
        });
    }

    slider_header.on( 'mounted move', function () {
        var thumbnail = thumbnails[ slider_header.index ];
      
        if ( thumbnail ) {
          if ( current ) {
            current.classList.remove( 'is-active' );
          }
      
          thumbnail.classList.add( 'is-active' );
          current = thumbnail;
        }

       
    });

    slider_header.on( 'autoplay:playing', function ( rate ) {

        for ( var i = 0; i < bars.length; i++ ) {
            bars[i].style.width = String( 100 * ( rate )) + '%';
        }

    });

    slider_header_image.mount();
    slider_header.mount();

}

function changeBackgroundMenu() 
{
    const menu_accueil =  document.querySelector('.header-menu-is-accueil')
    const ratio_to_show = 10;

    if(!menu_accueil)
    {
        return;
    }

    function changeBackground() {
        let scrollTop =  window.scrollY;
        if(scrollTop >= ratio_to_show)
        {
            menu_accueil.classList.add('show_background')
        }
        else {
            if(menu_accueil.classList.contains('show_background'))
            {
                menu_accueil.classList.remove('show_background')
            }
        }
    }

    changeBackground()
    window.addEventListener('scroll',function() {
        changeBackground();
    }, { passive: true });
}
